import ProfileNotification from './ProfileNotification';

export default ProfileNotification;
